import validate from "/opt/jenkins/workspace/Tenda/node_modules/.pnpm/nuxt@4.2.2_@parcel+watcher@2.5.1_@vue+compiler-sfc@3.5.26_cac@6.7.14_db0@0.3.4_eslint@8_6c76a691db215ce46e89c923e94f182e/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/jenkins/workspace/Tenda/node_modules/.pnpm/nuxt@4.2.2_@parcel+watcher@2.5.1_@vue+compiler-sfc@3.5.26_cac@6.7.14_db0@0.3.4_eslint@8_6c76a691db215ce46e89c923e94f182e/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "account-mobile-only": () => import("/opt/jenkins/workspace/Tenda/middleware/account-mobile-only.js"),
  auth: () => import("/opt/jenkins/workspace/Tenda/middleware/auth.js"),
  guest: () => import("/opt/jenkins/workspace/Tenda/middleware/guest.js"),
  "order-pay-result-layout": () => import("/opt/jenkins/workspace/Tenda/middleware/order-pay-result-layout.js"),
  role: () => import("/opt/jenkins/workspace/Tenda/middleware/role.js")
}